/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme'
import { CoreModule } from './@core/core.module'
import { SnakeCasePipe } from './@theme/pipes'
import { ThemeModule } from './@theme/theme.module'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent, RequiredArrayDirective } from './app.component'
import { AuthenticationModule } from './authentication/authentication.module'
import { FFService } from './ff/ff.service'
import { AuthenticationInterceptor } from './ff/intercetors/authentication/authconfig.interceptor'
import { ApplicationService } from './ff/services/application/application.service'
import { EditUserComponent } from './pages/edit_user/edit_user.component'
import { EditUserModule } from './pages/edit_user/edit_user.module'
import { SessionTimeoutDialog } from './pages/session_timeout_dialog/session_timeout_dialog.component'
import { SessionTimeoutDialogModule } from './pages/session_timeout_dialog/session_timeout_dialog.module'

@NgModule( {
  declarations: [
    AppComponent,
    RequiredArrayDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,

    ThemeModule.forRoot(),

    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot( {
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    } ),
    CoreModule.forRoot(),

    AuthenticationModule,
    EditUserModule,
    SessionTimeoutDialogModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    FFService,
    ApplicationService,
    SnakeCasePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
  ],
  entryComponents: [EditUserComponent, SessionTimeoutDialog],
} )
export class AppModule {
}
